import React from 'react';
import CancelReasons from '../../components/AdminNext/CancelReasons';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Cancel reasons — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <CancelReasons />
      </HeadLessLayout>
    )
  };
}

export default action;
